import React from "react"
import { useEffect, useState } from "react"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  TablePagination,
  Box,
  FormControl,
  InputLabel,
  Popover,
  Typography,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import {
  ApiCopySopperList,
  ApiDeleteUser,
  ApiGenerateLoginToken,
  ApiGetAllRoles,
  ApiGetShopperList,
  ApiGetShopperListExcel,
  ApiPutUpdateShopperApplicationStatus,
} from "../../../apiService/Core/Apicall.tsx"
import moment from "moment"
import { toast } from "react-toastify"
import { filterOptions, kmOptions, statusOptions } from "../../../global/constants/globalContants.ts"
import Dcrage from "../OrphanAllocation/Dcrage.tsx"
import { useShopperDetails } from "../../../global/ShopperDetailsUtils.ts"
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import CheckIcon from '@mui/icons-material/Check';
import { Autocomplete as GoogleAutocomplete } from "@react-google-maps/api";
import { CancelOutlined } from "@mui/icons-material"


const stateOptions = [
  { label: "Victoria", value: "VIC" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Queensland", value: "QLD" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "New South Wales", value: "NSW" },
  { label: "Tasmania", value: "TAS" },
  { label: "Northern Territory", value: "NT" },
];
interface LocationData {
  city: string;
  state: string;
}
const ShoppersList: React.FC = () => {

  const getInitialData = () => {
    const saved = sessionStorage.getItem("antiq");
    if (saved) {
      return JSON.parse(saved);
    }
    return {
      searchShopper: [],
      state: "",
      ageFrom: "",
      ageTo: "",
    };
  };

  const initialData = getInitialData();

  const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
  const [shoppersList, setShoppersList] = useState<any>([])
  const [roles, setRoles] = useState<any>([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(50)
  const [selectedFilter, setSelectedFilter] = useState<any>(null)
  const [selectedkm, setSelectedkm] = useState<any>(null)
  const navigate = useNavigate()
  const [selectedShopper, setSelectedShopper] = useState<any>()
  const [searchAge, setsearchAge] = useState<any>([])
  const [shopperlist, setshopperlist] = useState<any>([]);
  const [datalength, setdatalength] = useState<any>(null);
  const [searchShopper, setsearchShopper] = useState<any>(initialData.searchShopper);
  const [state, setState] = useState<any>(initialData.state);
  const [ageFrom, setAgeFrom] = useState<any>(initialData.ageFrom);
  const [ageTo, setAgeTo] = useState<any>(initialData.ageTo);
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const [reasonForDeactive, setReasonForDeactive] = useState("");
  const [pendingUserId, setPendingUserId] = useState(null);
  const [pendingStatus, setPendingStatus] = useState("");
  const [anchorEl2, setAnchorEl2] = useState<HTMLElement | null>(null);
  const [activeLocation, setActiveLocation] = useState<LocationData | null>(null);
  const [autocomplete, setAutocomplete] = useState<any>(null);
  const [inputValue, setInputValue] = useState("");
  const [suburb, setSuburb] = useState<string | null>(null);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [openCopyPoup, setOpenCopyPopup] = useState<boolean>(false)
  const [copyData, setCopyData] = useState<any>(null)
  const [copyType, setCopyType] = useState<string>("")

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    city: string,
    state: string
  ) => {
    console.log("Hello")
    setAnchorEl2(event.currentTarget);
    setActiveLocation({ city, state });
  };

  useEffect(() => {
    const data = {
      searchShopper,
      state,
      ageFrom,
      ageTo,
    };

    sessionStorage.setItem("antiq", JSON.stringify(data));
  }, [searchShopper, state, ageFrom, ageTo]);


  const handleClose2 = () => {
    setAnchorEl2(null);
    setActiveLocation(null);
  };

  const open = Boolean(anchorEl2);

  const timestamp = new Date()
    .toISOString()
    .replace(/[-:T.Z]/g, '')  // remove all non-numeric symbols
    .slice(0, 14); // keep only YYYYMMDDHHMMSS




  const navigateToViewShopperApplication = (shopper: any) => {
    navigate("/admin/shoppers/edit_shopper_profile", {
      state: { shopperDetails: shopper },
    })
  }
  // const getShopperList = async () => {
  //   try {
  //     const data = `?offset=0${searchShopper?.length > 0 ? `&search=${searchShopper}` : ''}`
  //     const res = await ApiGetShopperList(data)
  //     setshopperlist(res.data)
  //     const defaultselected = (res.data?.filter(item => item.firstName !== ''))
  //     // setSelectedShopper(defaultselected[0])

  //   } catch (error) {
  //     alert(error)
  //   }
  // }
  // useEffect(() => {
  //   getShopperList()
  // }, [searchShopper])

  useEffect(() => {
    handleGetApiCall()
  }, [searchShopper, rowsPerPage, page, state, ageFrom, ageTo, latitude, longitude, selectedkm])

  const navigateToLoginShopper = async (shopper: any) => {

    try {
      const data = {
        adminUserId: localStorage.getItem('userRole'),
        targetUserId: shopper.userId,
        ipAddress: '127.0.0.1',
        browserName: 'Google chrome'

      }
      const res = await ApiGenerateLoginToken(data)
      if (res.success) {
        window.open(`${process.env.REACT_APP_SHOPPER_SITE}?adminuserid=${localStorage.getItem('userId')}&validation=${res.data.token}`, '_blank');
      }
    } catch (error) {

    }
    // navigate("/admin/shoppers/edit_shopper_profile", {
    //   state: { shopperDetails: shopper },
    // })
  }

  useEffect(() => {
    const fetchData = async () => {
      await handleGetApiCallRoles()
      // Set default filter to "Active" on component mount
      const defaultFilter = filterOptions[0]
      setSelectedFilter(defaultFilter)
      await handleGetApiCall(defaultFilter.value)
    }
    fetchData()
    return () => { }
  }, [])

  const handleGetApiCallRoles = async () => {
    const data: any = {}
    try {
      const response: any = await ApiGetAllRoles(data)
      setRoles(response.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handleGetApiCall = async (status?: string) => {
    setShoppersList([]);
    try {
      // Use the provided status or fall back to selectedFilter or default to 'active'
      const filterStatus = status || selectedFilter?.value || "active"
      const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}&status=${filterStatus}${searchShopper.length > 0 ? `&search=${searchShopper}` : ''}${searchAge.length > 0 ? `&age=${searchAge}` : ''}${state ? `&state=${state}` : ""}${ageFrom ? `&ageFrom=${ageFrom}` : ""}${ageTo ? `&ageTo=${ageTo}` : ''}${latitude ? `&subLat=${latitude}` : ''}${longitude ? `&subLong=${longitude}` : ''}${(latitude && selectedkm) ? `&kilometerRange=${selectedkm?.value}` : ""}`
      const res = await ApiGetShopperList(data)
      setShoppersList(res.data)
      setdatalength(res.totalCount)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handleFilterChange = async (event: any, newValue: any) => {
    setSelectedFilter(newValue)
    setPage(0) // Reset pagination to first page when filter changes
    if (newValue) {
      await handleGetApiCall(newValue.value)
    }
  }
  const handleKMChange = async (event: any, newValue: any) => {
    setSelectedkm(newValue)
    setPage(0)
  }

  const handleStatusChange = async (event: any, newValue: any, userId: any) => {
    if (!newValue) return;

    if (newValue.value === "deActivated") {
      setPendingUserId(userId);
      setPendingStatus("deActivated");
      setOpenReasonDialog(true);
      return;
    }

    try {
      const payload = { userId, status: newValue.value };
      await ApiPutUpdateShopperApplicationStatus(payload);
      toast.success("Status updated successfully");
      await handleGetApiCall();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };


  // Pagination handlers
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(Number.parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleShopperExcel = async () => {
    try {
      // let data = `?status=${selectedFilter.value}`
      const filterStatus = selectedFilter?.value || "active"
      const data = `?status=${filterStatus}${searchShopper.length > 0 ? `&search=${searchShopper}` : ''}${searchAge.length > 0 ? `&age=${searchAge}` : ''}${state ? `&state=${state}` : ""}${ageFrom ? `&ageFrom=${ageFrom}` : ""}${ageTo ? `&ageTo=${ageTo}` : ''}${latitude ? `&subLat=${latitude}` : ''}${longitude ? `&subLong=${longitude}` : ''}`
      const res = await ApiGetShopperListExcel(data)
      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Shopperlist_${timestamp}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert(error)
    }
  }

  const handleSubmitDeactiveReason = async () => {
    if (!reasonForDeactive || reasonForDeactive.trim().length === 0) {
      alert("Reason is required");
      return;
    }

    try {
      const payload = {
        userId: pendingUserId,
        status: pendingStatus,
        rejectReason: reasonForDeactive
      };

      await ApiPutUpdateShopperApplicationStatus(payload);

      toast.success("Shopper Deactivated Successfully");

      setOpenReasonDialog(false);
      setReasonForDeactive("");
      setPendingUserId(null);
      setPendingStatus("");

      await handleGetApiCall();
    } catch (error) {
      toast.error("Error updating status");
    }
  };


  // Get current page data
  // const currentShoppers = shoppersList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)


  const handleDeleteUser = async (userId: number) => {
    const isdelete = window.confirm("Are you sure you want to delete this shopper?")
    if (isdelete) {
      try {
        const data = `?userId=${userId}`
        const res = await ApiDeleteUser(data)
        if (res?.status) {
          handleGetApiCall()
        }
      } catch (error: any) {
        toast.error(error?.message)
      }
    }
  }

  const handelOpenCopyPopup = async (type: string) => {
    try {
      const filterStatus = selectedFilter?.value || "active"
      const data = `?status=${filterStatus}${searchShopper.length > 0 ? `&search=${searchShopper}` : ''}${searchAge.length > 0 ? `&age=${searchAge}` : ''}${state ? `&state=${state}` : ""}${ageFrom ? `&ageFrom=${ageFrom}` : ""}${ageTo ? `&ageTo=${ageTo}` : ''}${latitude ? `&subLat=${latitude}` : ''}${longitude ? `&subLong=${longitude}` : ''}&type=${type}`
      const res = await ApiCopySopperList(data)
      setCopyData(res.data.join(","))
      setOpenCopyPopup(true)
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const copyDetails = async () => {
    try {
      await navigator.clipboard.writeText(copyData);
      toast.success("Copied successfully!");
    } catch (error) {
      console.log("Error while Copying", error)

    }
  }

  return (
    <div className="w-100 p-2">
      <Box className='bg-white border-10 p-2 p-md-3'>
        <Box className="w-100">
          <Typography className="fs-42 text-center">Shoppers List</Typography>
        </Box>

        {/* Filter Section */}
        <Grid className='w-100 mb-4 mt-4' justifyContent={'space-between'} gap={2} container>
          {/* <Box sx={{ mb: 3, ml: 2, p: 2, display: "flex", gap: 2, alignItems: "center", width: "99%", justifyContent: "space-between" }}> */}
          <Grid size={{ xs: 12, md: 'auto' }} flexDirection={{ xs: "column", md: "row" }} sx={{ display: "flex", gap: 2 }}>
            <Autocomplete
              options={filterOptions}
              value={selectedFilter}
              getOptionLabel={(option) => option.label}
              onChange={handleFilterChange}
              renderInput={(params) => <TextField {...params} label="Filter by Status" />}
              sx={{ width: { xs: "100%", md: 200 } }}
            />
            {/* <Autocomplete
            options={shopperlist?.filter(item => item.firstName !== '')}
            value={selectedShopper}
            getOptionLabel={(option: any) => `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`}
            isOptionEqualToValue={(option: any, value: any) =>
              option.userId === value.userId || option.emailId === value.emailId
            }
            filterOptions={(options, { inputValue }) =>
              options.filter((option) => {
                const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                const email = option.emailId?.toLowerCase() || '';
                const search = inputValue.toLowerCase();
                return fullName.includes(search) || email.includes(search);
              })
            }
            onChange={(event, newValue: any) => {
              setSelectedShopper(newValue)
            }}
            onInputChange={(event, newInputValue: string) => {
              setsearchShopper(newInputValue);  // 👈 update variable when user types
            }}
            renderInput={(params) => <TextField {...params} label='Search Shopper' />}
            sx={{ minWidth: 500 }}
          /> */}
            <FormControl>
              {/* <InputLabel>Search Shopper</InputLabel> */}
              <TextField value={searchShopper} label="Search Shopper" onChange={(e) => { setsearchShopper(e.target.value) }} />
            </FormControl>
            <FormControl sx={{ width: { xs: "100%", md: 180 } }}>
              <Autocomplete
                disablePortal
                id="mm-autocomplete"
                options={stateOptions}
                getOptionLabel={(option: any) => `${option?.label}`}
                value={stateOptions.find((option: any) => option.value === state) || null}
                onChange={(event, newValue: any) => {
                  setState(newValue?.value || null)
                }}
                defaultValue=""
                renderInput={(params) => <TextField {...params} label="Select State" />}
              />
            </FormControl>
            <FormControl sx={{ width: { xs: "100%", md: 120 } }}>
              <TextField
                label="Age From"
                type="number"
                value={ageFrom}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^[0-9]+$/.test(value)) {
                    setAgeFrom(value);
                  }
                }}
              />
            </FormControl>

            <FormControl sx={{ width: { xs: "100%", md: 120 } }}>
              <TextField
                label="Age To"
                type="number"
                value={ageTo}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^[0-9]+$/.test(value)) {
                    setAgeTo(value);
                  }
                }}
              />
            </FormControl>

            <GoogleAutocomplete
              onLoad={(auto) => setAutocomplete(auto)}
              onPlaceChanged={() => {
                const place = autocomplete?.getPlace();

                if (!place?.geometry) return;

                const suburbComponent = place.address_components?.find((component: any) =>
                  component.types.includes("locality")
                );

                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();

                setSuburb(suburbComponent?.long_name || null);
                setLatitude(lat);
                setLongitude(lng);
                setInputValue(place.formatted_address || "");
              }}
              options={{
                types: ["(regions)"],
                componentRestrictions: { country: "au" },
              }}
            >
              <TextField
                fullWidth
                size='medium'
                label="Select Suburb"
                value={inputValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setInputValue(value);

                  if (!value) {
                    setSuburb(null);
                    setSelectedkm(null)
                    setLatitude(null);
                    setLongitude(null);
                  }
                }}
              />
            </GoogleAutocomplete>
            {latitude && (
              <Autocomplete
                options={kmOptions}
                value={selectedkm}
                getOptionLabel={(option) => option.label}
                onChange={handleKMChange}
                renderInput={(params) => <TextField {...params} label="Distance" />}
                sx={{ width: { xs: "100%", md: 200 } }}
              />
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 'auto' }} spacing={2} display={'flex'} justifyContent={'end'}>
            <Button
              variant="contained"
              className="table-row-background mr-2"
              onClick={() => { setCopyType("Emails"); handelOpenCopyPopup("email") }}
            >
              Copy Email
            </Button>
            <Button
              variant="contained"
              className="table-row-background mr-2"
              onClick={() => { setCopyType("Contacts"); handelOpenCopyPopup("phone") }}
            >
              Copy Contact
            </Button>
            <Button
              variant="contained"
              className="table-row-background"
              onClick={() => { handleShopperExcel() }}
            >
              Download As Excel
            </Button>
          </Grid>
          {/* </Box> */}
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                {["Profile Pic", "User Name", "Contact No", "Email", "Start Date", "State", "Suburb", "Age", ...(selectedkm && latitude ? ["Distance"] : []), ...(selectedFilter?.value !== "approve" ? ["Status"] : []), "Edit", "Login", ...(selectedFilter?.value === "approve" ? ["Delete"] : []), <ContactEmergencyIcon></ContactEmergencyIcon>, <TextSnippetIcon></TextSnippetIcon>, ""].map((item, index) => (
                  <TableCell key={index} style={{ color: "#fff" }}>
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {shoppersList?.map((user: any) => (
                <TableRow key={user.userId}>
                  <TableCell><Box component='img' src={user.profilePicUrl} height='50px'></Box></TableCell>
                  <TableCell onClick={(e) => handleShopperDetailsClick(e, user.userId)}>{user.firstName} {user.lastName}</TableCell>
                  <TableCell>{user.contactNo}</TableCell>
                  <TableCell>{user.emailId}</TableCell>
                  <TableCell>{moment(user.createdOn).format('DD/MM/YYYY')}</TableCell>
                  <TableCell>{user.state}</TableCell>
                  <TableCell sx={{ cursor: "pointer", textDecoration: 'underline' }} onClick={(e) => handleClick(e, user.city, user.state)}>{user.city}</TableCell>
                  <TableCell>
                    {(() => {
                      const dob = new Date(user.dob);
                      const diffMs = Date.now() - dob.getTime();
                      const ageDate = new Date(diffMs);
                      return Math.abs(ageDate.getUTCFullYear() - 1970);
                    })()}
                  </TableCell>
                  {selectedkm && latitude && (
                    <TableCell>
                      {user?.distanceInKm} km
                    </TableCell>)}
                  {selectedFilter?.value !== "approve" && (
                    <TableCell>
                      <div className="w-200">
                        <Autocomplete
                          options={statusOptions}
                          value={statusOptions.find((option) => option.value === (user?.userStatus?.userStatus || ""))}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) => handleStatusChange(event, newValue, user.userId)}
                          renderInput={(params) => <TextField {...params} label="Status" />}
                          fullWidth
                        />
                      </div>
                    </TableCell>
                  )}
                  <TableCell>
                    <Link
                      to={`/admin/shoppers/edit_shopper_profile/${user?.userId}`}
                      // variant="contained"
                      className="table-row-background link-btn"
                    // onClick={() => navigateToViewShopperApplication(user)}
                    >
                      Edit
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      className="table-row-background"
                      onClick={() => navigateToLoginShopper(user)}
                    >
                      Login
                    </Button>
                  </TableCell>
                  {selectedFilter?.value === "approve" && (<TableCell>
                    <Button
                      variant="contained"
                      className="table-row-background"
                      onClick={() => handleDeleteUser(user?.userId)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                  )}
                  <TableCell>
                    {user.driving_licence ? <CheckIcon></CheckIcon> : ""}
                  </TableCell>
                  <TableCell>
                    {user.shopperAgreementFileUrl ? <CheckIcon></CheckIcon> : ""}
                  </TableCell>
                  <TableCell>
                    {user?.shopperOtherDetails[0]?.isProceedWithStatementOfSupplier === true ? "SOS" : user?.shopperOtherDetails[0]?.isProceedWithABN === true ? "ABN" : ""}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        {/* Pagination component */}
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Popover
          open={open}
          anchorEl={anchorEl2}
          onClose={handleClose2}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            sx: {
              width: 500,
              height: 400,
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            },
          }}
        >
          {activeLocation && (
            <iframe
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              src={`https://www.google.com/maps?q=${encodeURIComponent(
                `${activeLocation.city}, ${activeLocation.state}`
              )}&output=embed`}
            />
          )}
        </Popover>
        <Popover
          // open={Boolean(anchorEl) && selectedIndex === index}
          open={Boolean(anchorEl) && clickedShopperId !== null}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Dcrage handleClose={handleClose} loanData={loanData} />
        </Popover>
      </Box>
      <Dialog open={openReasonDialog} onClose={() => setOpenReasonDialog(false)}>
        <DialogContent>
          <TextField
            required
            fullWidth
            label="Reason for Deactivation"
            value={reasonForDeactive}
            onChange={(e) => setReasonForDeactive(e.target.value)}
            sx={{
              width: "300px",
              ".MuiOutlinedInput-input": { padding: "10px" },
              ".MuiInputLabel-root": { top: "-6px" }
            }}
          />

          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                setOpenReasonDialog(false);
                setReasonForDeactive("");
                setPendingUserId(null);
                setPendingStatus("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="table-row-background"
              onClick={handleSubmitDeactiveReason}
            >
              Submit
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={openCopyPoup} fullWidth onClose={() => setOpenCopyPopup(false)}>
        <DialogActions className="d-flex align-items-center p-3 justify-content-between">
          <Typography variant="h5" fontWeight={'bold'}>Copy {copyType}</Typography>
          <IconButton className="m-0 p-0" onClick={() => setOpenCopyPopup(false)}><CancelOutlined /></IconButton>
        </DialogActions>
        <DialogContent className="d-flex pt-0 flex-column">
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              border: "1px solid #ddd",
              p: 2,
              borderRadius: 1,
              overflow: "auto",
            }}
          >
            {copyData?.split(",").map((item: string, index: number) => (
              <Typography
                key={index}
                sx={{
                  px: 1,
                  py: 0.5,
                  bgcolor: "#f5f5f5",
                  borderRadius: 1,
                  wordBreak: "break-word",
                }}
              >
                {item.trim()}
              </Typography>
            ))}
          </Box>
          <Box display="flex" justifyContent="end" mt={3}>
            <Button
              variant="contained"
              className="table-row-background"
              onClick={() => { copyDetails() }}
            >
              Copy All
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

    </div>
  )
}

export default ShoppersList